
import { MsalComponentContainer, MessageBox } from "./MsalComponentStyles";// msalLoadingComponent.js
export const msalLoadingComponent = () => (
    <MsalComponentContainer>
      <MessageBox>Authentication in progress...</MessageBox>
    </MsalComponentContainer>
  );